import TaskInput from './components/TaskInput'

import './App.css'

const App = () => <TaskInput />

export default App
